import { render, staticRenderFns } from "./StatusFormModal.vue?vue&type=template&id=2188ea88"
import script from "./StatusFormModal.vue?vue&type=script&lang=js"
export * from "./StatusFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports